/**
 * @deprecated Import from `@fluentui/react` package instead.
 */
export { Text } from '@fluentui/react/lib/Text';
